import { lazy, Suspense } from "react";
import type { ApexOptions } from "apexcharts";
import { Spinner } from "./Spinner";

const ReactApexChart = lazy(() => import("react-apexcharts"));

export type ApexChartType = NonNullable<ApexOptions["chart"]>["type"];

interface ApexChartProps {
  options: ApexOptions;
  series: ApexOptions["series"];
  type?: ApexChartType;
  height?: string | number;
}

export function ApexChart({ options, series, type, height }: ApexChartProps) {
  const themedOptions: ApexOptions = {
    ...options,
    chart: {
      fontFamily: "Public Sans, sans-serif",
      foreColor: "#72828f",
      background: "transparent",
      toolbar: { show: false, ...options.chart?.toolbar },
      ...options.chart,
    },
    grid: { borderColor: "#edf0f5", strokeDashArray: 3, padding: { left: 8, right: 8 }, ...options.grid },
    legend: {
      fontSize: "11px",
      fontWeight: 500,
      // width/height non sono nei tipi di apexcharts ma la libreria li legge (tema legacy)
      markers: { width: 8, height: 8, radius: 4 } as NonNullable<ApexOptions["legend"]>["markers"],
      itemMargin: { horizontal: 10, vertical: 4 },
      ...options.legend,
    },
    tooltip: { theme: "light", ...options.tooltip },
    noData: {
      text: "No data for this period",
      align: "center",
      verticalAlign: "middle",
      style: { color: "#72828f", fontSize: "12px" },
      ...options.noData,
    },
  };
  return (
    <div className="as-apex-chart min-w-0 w-full">
      <Suspense fallback={<Spinner label="Loading chart" />}>
        <ReactApexChart width="100%" options={themedOptions} series={series} type={type} height={height} />
      </Suspense>
    </div>
  );
}
